import { render } from "./App.vue?vue&type=template&id=a69736b6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a69736b6&lang=css"

import exportComponent from "/etc/ec/object_storage/object_storage_ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__